import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import Slider from '../components/slider/Slider';
import Gallery2 from '../components/gallery2/Gallery2';
import { MD } from '../global_vars';
import { delay } from '../utils/async';
import { ResizeAF } from '../utils/ResizeAF';
import { getCoords } from '../utils/miscellanea';
import { CountUp } from 'countup.js';
import Quote from '../components/quote/Quote';
import SliderControls from '../mixins/SliderControls';

const pathsChunks: Array<Array<HTMLElement>> = [];

@Component({
  mixins: [SliderControls],
  components: {
    Slider,
    Gallery2,
    Quote
  }
})
export default class VMMain extends Vue {
  showVideo = false;
  playVideo = false;
  muteVideo = true;

  @Watch('muteVideo')
  onMuteVideoChange(val: boolean) {
    if (val == false) {
      // @ts-ignore
      this.$refs.video.muted = false;
      // @ts-ignore
      this.$refs.video.play();
    } else {
      // @ts-ignore
      this.$refs.video.muted = true;
    }
  }

  mounted(): void {
    if (!MD.mobile()) {
      this.showVideo = true;

      const mapSvg = <HTMLElement>(document.getElementsByClassName('main__map')[0]);

      let mapActive = false;
      ResizeAF.instance().on((ty) => {
        if (!mapActive) {
          const coords = getCoords(mapSvg);
          if (coords.top - window.innerHeight / 1.5 <= ty && ty <= coords.bottom) {
            mapActive = true;
            this.showMap();
            this.startCounters();
          }
        }
      });

      ResizeAF.instance().trigger();
    } else {
      const mapSvg = <HTMLElement>(document.getElementsByClassName('main__map')[0]);
      mapSvg.classList.add('mapsvg--visible');
    }
  }

  startVideo() {
    if (this.playVideo == false) {
      this.playVideo = true;
      this.$nextTick(() => this.muteVideo = false);
    } else {
      this.playVideo = false;
      (<HTMLVideoElement>this.$refs.video).pause();
    }
  }

  startCounters() {
    const options = {
      separator: ' ',
    };

    const stats = [
      {id: 'stat1', val: 17},
      {id: 'stat2', val: 100},
      {id: 'stat3', val: 5000000},
      {id: 'stat4', val: 3000},
    ];

    stats.forEach((el) => {
      // @ts-ignore
      const demo = new CountUp(this.$refs[`${el.id}`], el.val, options);
      if (!demo.error) {
        demo.start();
      } else {
        console.error(demo.error);
      }
    });
  }

  async showMap() {
    this.prepareMap();

    await delay(250);

    for (let i = 0; i < pathsChunks.length; i++) {
      await delay(40);

      pathsChunks[i].forEach((el) => {
        (<HTMLDivElement>el).style.opacity = '1';
      });
    }
  }

  private prepareMap(): void {
    if (pathsChunks.length) return;

    const mapSvg = document.getElementsByClassName('mapsvg')[0];

    const paths = [];

    for (let i = 0; i < mapSvg.childNodes[0].childNodes.length; i++) {
      const el = mapSvg.childNodes[0].childNodes[i];
      if (el.nodeName == 'path' || el.nodeName == 'g') {
        paths.push(el);
      }
    }

    for (let i = paths.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * i);
      // @ts-ignore
      const temp = paths[i];
      paths[i] = paths[j];
      paths[j] = temp;
    }

    const chunk = 20;
    for (let i = 0, j = paths.length; i < j; i += chunk) {
      pathsChunks.push(paths.slice(i, i + chunk));
    }
  }
}
